import React, { useRef, useState } from "react";

export const MaterialSymbol = ({ name, className = "" }) => (
  <span className={`material-symbols-outlined ${className}`} aria-hidden="true">
    {name}
  </span>
);

export const SearchIcon = () => <MaterialSymbol name="search" />;
const CalendarIcon = () => <MaterialSymbol name="calendar_month" />;
const ChevronIcon = () => <MaterialSymbol name="arrow_drop_down" />;
const InfoIcon = () => <MaterialSymbol name="info" className="icon-info" />;
export const DocIcon = () => <MaterialSymbol name="description" />;
export const BedIcon = () => <MaterialSymbol name="bed" />;
export const ForkKnifeIcon = () => <MaterialSymbol name="restaurant" />;

export const Field = ({ label, required, info, className = "", children }) => (
  <div className={`cb-form-group ${className}`}>
    <label className="cb-form-label">
      {label}
      {required && <span className="required-mark"> *</span>}
      {info && <span className="label-info"><InfoIcon /></span>}
    </label>
    {children}
  </div>
);

export const TextInput = ({ placeholder, defaultValue, value, onChange, icon, disabled, onIconClick, inputId }) => (
  <div className="input-wrap">
    <input id={inputId} type="text" className="text-input" placeholder={placeholder} defaultValue={defaultValue} value={value} onChange={onChange} onFocus={onIconClick} disabled={disabled} />
    {icon && (onIconClick ? (
      <button type="button" className="input-icon input-icon-button" onClick={onIconClick} aria-label="Open search">{icon}</button>
    ) : <span className="input-icon">{icon}</span>)}
  </div>
);

const formatDate = (value) => {
  if (!value) return "";
  const [year, month, day] = value.split("-");
  return `${day}-${month}-${year}`;
};

export const DateInput = ({ placeholder = "DD-MM-YYYY", value: controlledValue, onChange }) => {
  const pickerRef = useRef(null);
  const [internalValue, setInternalValue] = useState("");
  const value = controlledValue === undefined ? internalValue : controlledValue;
  const openPicker = () => pickerRef.current?.showPicker ? pickerRef.current.showPicker() : pickerRef.current?.click();
  const handleChange = (event) => {
    const nextValue = event.target.value;
    if (controlledValue === undefined) setInternalValue(nextValue);
    onChange?.(nextValue);
  };

  return (
    <div className="input-wrap">
      <input type="text" className="text-input" placeholder={placeholder} value={formatDate(value)} onClick={openPicker} />
      <input ref={pickerRef} type="date" className="native-date-picker" value={value} onChange={handleChange} tabIndex={-1} aria-hidden="true" />
      <button type="button" className="input-icon input-icon-button" onClick={openPicker} aria-label="Choose date"><CalendarIcon /></button>
    </div>
  );
};

export const SelectInput = ({ defaultValue, value, onChange, options }) => (
  <div className="input-wrap">
    <select
      className="text-input select-input"
      defaultValue={value === undefined ? defaultValue : undefined}
      value={value}
      onChange={onChange}
    >
      {options.map((option) => <option key={option} value={option}>{option}</option>)}
    </select>
    <span className="input-icon"><ChevronIcon /></span>
  </div>
);

export const Stepper = ({ value, onDecrease, onIncrease }) => {
  const [internalValue, setInternalValue] = useState(Number(value) || 0);
  const isControlled = Boolean(onDecrease || onIncrease);
  const displayedValue = isControlled ? value : internalValue;
  const decrease = () => onDecrease ? onDecrease() : setInternalValue((current) => Math.max(0, current - 1));
  const increase = () => onIncrease ? onIncrease() : setInternalValue((current) => current + 1);

  return (
    <div className="stepper">
      <button type="button" className="stepper-btn" aria-label="Decrease value" onClick={decrease}><MaterialSymbol name="remove" /></button>
      <input type="text" className="stepper-input" value={displayedValue} readOnly />
      <button type="button" className="stepper-btn" aria-label="Increase value" onClick={increase}><MaterialSymbol name="add" /></button>
    </div>
  );
};

export const SectionHeader = ({ icon, title, right }) => (
  <div className="cb-section-header">
    <span className="cb-section-title">{icon}{title}</span>
    {right && <span className="cb-section-right">{right}</span>}
  </div>
);

export const CheckMark = () => <MaterialSymbol name="check" className="icon-check" />;
